










































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import { SaveHospital } from "@/request/system";
@Component({})
export default class SystemUserDetail extends Vue {
  @Prop()
  private type: any;
  private hospital: any = {
    医院名称: "",
    所属医院: "",
    备注: ""
  };
  @Prop()
  private targetHospital: any;
  /**
   * @description 关闭窗口
   */
  private close() {
    this.$emit("close");
  }
  /**
   * @description 保存
   */
  private save() {
    // console.log(this.hospital);
    if (!this.hospital["医院名称"]) {
      this.$message.warning("机构名称必须填写");
      return;
    }
    if (!this.hospital["所属医院"]) {
      this.$message.warning("所属医院必须填写");
      return;
    }
    const params: any = this.hospital;
    params["机构名称"] = params["医院名称"];
    SaveHospital(this, params).then((data: any) => {
      if (this.type === "add") {
        this.$message.success("保存成功");
      } else {
        this.$message.success("编辑成功");
      }
      this.$emit("refresh");
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    if (this.type === "add") {
      this.hospital = {};
    } else if (this.type === "compose") {
      this.hospital = _.cloneDeep(this.targetHospital);
    }
  }
}
